import React from 'react';

import styles from './index.module.css';

const Separator = () => <hr className={styles.separator} />;

export default Separator;
